{
  "version": 1,
  "asset_id": "4db840b7-cebb-4e62-8784-63d6f9ac7866",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/4db840b7-cebb-4e62-8784-63d6f9ac7866/destination-roofing-owner-sales-team-crystal-river-fl-960w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/4db840b7-cebb-4e62-8784-63d6f9ac7866/destination-roofing-owner-sales-team-crystal-river-fl-960w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-960w.avif",
  "size": 32257,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
